import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { DocumentType } from '@/modules/document/types/document-type.type.ts';
import type { DocumentTypeDto } from '@/modules/document/dto/document-type.dto.ts';

export class DocumentTypeAdapter {
  private static map(response: DocumentTypeDto): DocumentType {
    return {
      id: response.DT_ID,
      name: response.Название,
      mask: response.Маска,
    };
  }

  static mapList(response: ItemsDto<DocumentTypeDto>) {
    return response.items.map(DocumentTypeAdapter.map);
  }
}
